<template>
  <b-card-code title="Contextual states">
    <b-card-text>
      <!-- <span>Use </span>
      <code>&lt;b-form-valid-feedback&gt;</code>
      <span> and </span>
      <code>&lt;b-form-invalid-feedback&gt;</code>
      <span> form sub-components for input validation.</span> -->
      Apply feedback to the form to further indicate the valid and invalid status of the inputs to helps users recognize the field that needs to be corrected.
    </b-card-text>

    <b-row>

      <!-- valid input -->
      <b-col md="6">
        <b-form-group
          label="Valid State"
          label-for="input-valid"
        >
          <b-form-input
            id="input-valid"
            :state="true"
            placeholder="Valid"
          />
          <b-form-valid-feedback>
            This is valid state.
          </b-form-valid-feedback>
        </b-form-group>
      </b-col>

      <!-- invalid input -->
      <b-col md="6">
        <b-form-group
          label="Invalid State"
          label-for="input-invalid"
        >
          <b-form-input
            id="input-invalid"
            :state="false"
            placeholder="Invalid"
          />
          <b-form-invalid-feedback>
            This is invalid state.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <div class="form-label-group infield-float">
          <b-form-input
            id="floating-label4"
            :state="true"
            placeholder="Label Placeholder"
            name="trueInfo"
          />
          <b-form-valid-feedback>
            This is valid state.
          </b-form-valid-feedback>
          <label for="floating-label4">Label-placeholder</label>
        </div>
      </b-col>
      <b-col md="6">
        <div class="form-label-group infield-float">
          <b-form-input
            id="floating-label5"
            :state="false"
            placeholder="Label Placeholder"
            name="falseInfo"
          />
          <b-form-valid-feedback>
            This is invalid state.
          </b-form-valid-feedback>
          <label for="floating-label5">Label-placeholder</label>
        </div>
      </b-col>
    </b-row>

    <template #code>
      {{ codeStates }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BFormInput, BRow, BCol, BFormInvalidFeedback, BFormValidFeedback, BCardText, BFormGroup,
} from 'bootstrap-vue'
import { codeStates } from './code'

export default {
  components: {
    BCardCode,
    BFormInput,
    BCardText,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BRow,
    BFormGroup,
    BCol,
  },
  data() {
    return {
      codeStates,
      trueInfo: 'what?',
      falseInfo: 'what?',
    }
  },
}
</script>
